import { Router, Redirect } from "@reach/router";
import React from "react";
import {
  Dashboard,
  ReportingDashboard,
  State,
  Routing,
  Participant,
  CardSet,
} from "../pages";

const routes = (
  <Router>
    <Redirect
      from="/spa/automated-terminal-registration-system"
      to="/"
      noThrow
    />
    <Redirect from="/automated-terminal-registration-system" to="/" noThrow />
    <Dashboard path="/" />
    <ReportingDashboard path="/reporting-dashboard" />
    <State path="/states" />
    <Routing path="/routing" />
    <Participant path="/participants" />
    <CardSet path="/card-set" />
  </Router>
);

export default routes;
